import { render, staticRenderFns } from "./EDocumentsForm.vue?vue&type=template&id=5f35ea9c&"
import script from "./EDocumentsForm.vue?vue&type=script&lang=js&"
export * from "./EDocumentsForm.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports